import { navigationNamespace } from "@/store/modules/navigation";
import { patientNamespace } from "@/store/modules/patient";
import { PopupDescription } from "@/store/types";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { defaultSwiperSettings } from "./util";

export const popupAnimationDuration = 150;

@Component({
  components: { swiper, swiperSlide }
})
export default class PopupContainer extends Vue {
  @Prop(Boolean)
  noHeader!: boolean;

  @Prop(Boolean)
  hide!: boolean;

  @Action("hidePopup", navigationNamespace)
  hidePopup!: Function;

  @Getter("name", navigationNamespace)
  popupName!: string;

  @Getter("isMobile", navigationNamespace)
  isMobile!: boolean;

  @Getter("popupDescription", patientNamespace)
  popupDescription!: PopupDescription;

  @Getter("now", patientNamespace)
  now!: any;

  // Checks to see if data has been
  // loaded before trying to render the popup
  // This lets the graphs use the server time and offset
  get hasNow() {
    return this.now;
  }

  $refs!: {
    popupSwiper: any;
  };

  get animationDuration() {
    return this.isMobile ? popupAnimationDuration : 0;
  }

  mounted() {
    if (!this.$refs.popupSwiper || !this.$refs.popupSwiper.swiper) {
      return;
    }
    this.$refs.popupSwiper.swiper.slideNext(this.animationDuration);
    this.$refs.popupSwiper.swiper.allowSlideNext = false;
  }

  slideChangeTransitionEnd() {
    const popupSwiper = this.$refs.popupSwiper.swiper;
    if (popupSwiper.realIndex === 0) {
      this.hidePopup();
    }
  }

  // slideChangeTransitionEnd() closes the popup
  beginHide() {
    if (!this.$refs.popupSwiper || !this.$refs.popupSwiper.swiper) {
      return;
    }
    this.$refs.popupSwiper.swiper.allowSlideNext = true;
    const animationDuration = this.animationDuration;
    this.$refs.popupSwiper.swiper.slidePrev(animationDuration);
  }

  popupSwiperOptions = Object.assign(defaultSwiperSettings, {
    // No differences from default
  });

  @Watch("hide", { immediate: true })
  onHideChange() {
    if (this.hide === true) {
      this.beginHide();
    }
  }
}
